/**
 * geometry.js — Shared 2D geometry helpers for the wall/door system.
 * All coordinates are in grid units (not pixels).
 */

/** Shortest distance from point (px,py) to the line segment (ax,ay)→(bx,by). */
export function pointToSegmentDist(px, py, ax, ay, bx, by) {
  const dx = bx - ax, dy = by - ay;
  const lenSq = dx * dx + dy * dy;
  if (lenSq === 0) return Math.hypot(px - ax, py - ay);
  const t = Math.max(0, Math.min(1, ((px - ax) * dx + (py - ay) * dy) / lenSq));
  return Math.hypot(px - (ax + t * dx), py - (ay + t * dy));
}

/** Midpoint of a segment defined by two {x,y} points. */
export function segmentMidpoint(a, b) {
  return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
}

/** Angle (radians) of the segment from a→b. */
export function segmentAngle(a, b) {
  return Math.atan2(b.y - a.y, b.x - a.x);
}
